import { GridColumnConfig } from '../../models/gridCoumnConfig';
import { FormattedValue } from '../formatted-text';

export const NormalCell = (column: GridColumnConfig) => {
  return (dataItem: any) => (
    <td>
      <FormattedValue value={dataItem.dataItem[column.field]} format={column.formatPattern} />
    </td>
  );
};
